export default "__VITE_ASSET__BCfsHAT6__"